import { NOTIFY_ADD, NOTIFY_CLEAR } from './actions';

const initialState = {

};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case NOTIFY_ADD: {

            return {
                ...state,
                notify: action.data
            }
        }

        case NOTIFY_CLEAR: {

            return {
                ...state,
                notify: {
                  notify_type: "CLEARED",
                  notify_data: {}
                }
            }
        }
        default: {
            return state
        };
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/notify/index.js